import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WPreviewPhotosView } from '@zola/svc-web-api-ts-client';

export function fetchPreviewPhoto(): Promise<WPreviewPhotosView> {
  return ApiService.get<WPreviewPhotosView>(`/web-api/v1/preview-photo`);
}
